// import React from "react";

// const MissionVision = () => {
//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>
//         Our <span style={styles.highlight}>Commitments</span>
//       </h2>
//       <div style={styles.cardWrapper}>
//         {/* MISSION */}
//         <div style={styles.outer}>
//           <div className="rotatingCircle">
//             <div style={styles.innerCircle}>
//               {/* <img src={missionIcon} alt="Mission" style={styles.icon} /> */}
//               <h3 style={styles.title}>MISSION</h3>
//               <p style={styles.text}>
//                 Empowering industries with innovation and integrity to achieve
//                 excellence.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* VISION */}
//         <div style={styles.outer}>
//           <div className="rotatingCircle">
//             <div style={styles.innerCircle}>
//               {/* <img src={visionIcon} alt="Vision" style={styles.icon} /> */}
//               <h3 style={styles.title}>VISION</h3>
//               <p style={styles.text}>
//                 To be a global leader delivering cutting-edge solutions for a
//                 better tomorrow.
//               </p>
//             </div>
//           </div>
//         </div>
//         <div style={styles.outer}>
//           <div className="rotatingCircle">
//             <div style={styles.innerCircle}>
//               {/* <img src={visionIcon} alt="Vision" style={styles.icon} /> */}
//               <h3 style={styles.title}>VALUE</h3>
//               <p style={styles.text}>
//                 To be a global leader delivering cutting-edge solutions for a
//                 better tomorrow.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Include internal style for hover animation */}
//       <style>{`
//         .rotatingCircle {
//           position: relative;
//           width: 280px;
//           height: 280px;
//           border-radius: 50%;
//           background-color: #ffd700;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: transform 0.6s ease;
//         }

//         .rotatingCircle:hover {
//           transform: rotate(360deg);
//         }

//         .rotatingCircle:hover .innerContent {
//           color: #FFD700;
//         }
//       `}</style>
//     </div>
//   );
// };

// // Internal JS styles
// const styles = {
//   container: {
//     padding: "50px 20px",
//   },
//   cardWrapper: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     gap: "40px",
//     maxWidth: "1200px",
//     margin: "0 auto",
//   },

//   heading: {
//     textAlign: "center",
//     fontSize: "44px",
//     fontWeight: "bold",
//     marginBottom: "40px",
//     color:"white",
//   },
//   highlight: {
//     color: "gold",
//   },
//   outer: {
//     position: "relative",
//     width: "280px",
//     height: "280px",
//   },
//   innerCircle: {
//     width: "85%",
//     height: "85%",
//     backgroundColor: "#025261",
//     borderRadius: "50%",
//     padding: "20px",
//     color: "#FFD700",
//     textAlign: "center",
//     boxSizing: "border-box",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     zIndex: 2,
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//   },
//   icon: {
//     width: "40px",
//     height: "40px",
//     margin: "0 auto 10px auto",
//   },
//   title: {
//     fontSize: "30px",
//     fontWeight: "bold",
//     marginBottom: "10px",
//     color: "white",
//     letterSpacing:"0px",
//   },
//   text: {
//     fontSize: "14px",
//     lineHeight: "1.6",
//   },
// };

// export default MissionVision;






import React from "react";

const MissionVision = () => {
  const items = [
    {
      title: "MISSION",
      text: "Empowering industries with innovation and integrity to achieve excellence.",
    },
    {
      title: "VISION",
      text: "To be a global leader delivering cutting-edge solutions for a better tomorrow.",
    },
    {
      title: "VALUE",
      text: "Building lasting trust through quality, transparency and customer commitment.",
    },
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>
        <span style={{ color: "white" }}>Our </span>
        <span style={styles.highlight}>Commitments</span>
      </h2>

      <div style={styles.cardWrapper}>
        {items.map((item, index) => (
          <div key={index} className="commitCard">
            <div className="cardAccent" />
            <h3 className="cardTitle">{item.title}</h3>
            <p className="cardText">{item.text}</p>
          </div>
        ))}
      </div>

      <style>{`
        .commitCard {
          position: relative;
          background-color: #ffffff;
          width: 300px;
          min-height: 190px;
          border-radius: 10px;
          padding: 28px 26px 24px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.18);
          box-sizing: border-box;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .commitCard:hover {
          transform: translateY(-6px);
          box-shadow: 0 14px 30px rgba(0,0,0,0.25);
        }

        .cardAccent {
          width: 42px;
          height: 4px;
          background-color: #ffd700;
          border-radius: 2px;
          margin-bottom: 16px;
        }

        .cardTitle {
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 1px;
          color: #025261;
          margin: 0 0 10px 0;
          font-family: 'Segoe UI', Arial, sans-serif;
        }

        .cardText {
          font-size: 14px;
          line-height: 1.65;
          color: #4a4a4a;
          margin: 0;
          font-family: 'Segoe UI', Arial, sans-serif;
        }

        @media (max-width: 900px) {
          .commitCard {
            width: 260px;
          }
        }

        @media (max-width: 768px) {
          h2 {
            font-size: 26px !important;
            letter-spacing: 0px !important;
          }
          .commitCard {
            width: 90%;
            max-width: 340px;
            min-height: unset;
            padding: 22px 20px 20px;
          }
          .cardTitle {
            font-size: 16px;
          }
          .cardText {
            font-size: 13px;
          }
        }

        @media (max-width: 420px) {
          .commitCard {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    padding: "50px 20px",
    backgroundColor: "#025261",
  },
  cardWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "24px",
    maxWidth: "1100px",
    margin: "0 auto",
  },
  heading: {
    textAlign: "center",
    fontSize: "36px",
    fontWeight: "bold",
    marginBottom: "36px",
    color: "white",
    letterSpacing: "0.5px",
    fontFamily: "'Segoe UI', Arial, sans-serif",
  },
  highlight: {
    color: "gold",
  },
};

export default MissionVision;